export const ADD_FLASH_MESSAGE = "ADD_FLASH_MESSAGE";
export const EMPTY_FLASH_MESSAGE = "EMPTY_FLASH_MESSAGE";
export const REMOVE_FLASH_MESSAGE = "REMOVE_FLASH_MESSAGE";

export const addFlashMessage = ({ type, messages, title }) => dispatch => {
  dispatch({ type: ADD_FLASH_MESSAGE, payload: { type, title, messages } });
};

export const removeFlashMessage = id => dispatch => {
  dispatch({ type: REMOVE_FLASH_MESSAGE, payload: id });
};

export const emptyFlashMessage = () => dispatch => {
  dispatch({ type: EMPTY_FLASH_MESSAGE });
};



// WEBPACK FOOTER //
// ./src/store/actions/flashMessage.js